import { ComponentProps } from "react";

import IconWithBG from "@/components/elements/IconWithBG";
import { RequestConnectorForm } from "@/features/connectors";
import { ConnectorsIcon } from "@/components/icons/domain-icons";

export function RequestConnector(
  props: ComponentProps<typeof RequestConnectorForm>,
) {
  return (
    <div className="w-full max-w-sm rounded-sm border bg-white p-4 dark:bg-gray-800">
      <div className="mb-2 flex items-center gap-3">
        <IconWithBG
          size="xs"
          icon={<ConnectorsIcon className="text-indigo-600" />}
          className="bg-indigo-600/20"
        />
        <div className="leading-none font-medium">Request a connector</div>
      </div>
      <RequestConnectorForm {...props} />
    </div>
  );
}
